export enum DASHBOARDVIEW {
    GENERAL = "GENERAL",
    LEADERBOARDS = "LEADERBOARDS",
}

export type seasonInfoProps = {
    BronzeTierCost: number
    EndDate: string
    GoldTierCost: number
    ItemRewards: string[]
    LeadeboardRewards: {
        StatName: string
        MaxRank: number
        PFactor: number
        Spread: number
        Pool: number
        Divisor: number
    }
    MarkRewardPool: number
    SeasonName: string
    SeasonNumber: number
    SilverTierCost: number
}

export type dashboardProps = {
    rank: string | null
    nextRank: string | null
    seasonPassProgress: number | null
    creditsUntilPromotion: number | null
    currentRankIcon: string | null
    bronzeTier: number | null
    silverTier: number | null
    goldTier: number | null
    promoModal: boolean
}

export type convertShardsToCreditsPayload = {
    shardAmount: number
    playerTitleId: string
}

export type contributeSeasonPassPayload = {
    playerTitleId: string
    playerId: string
    creditAmount: number
}
